import { render, staticRenderFns } from "./doorDetail.vue?vue&type=template&id=16453646&scoped=true&"
import script from "./doorDetail.vue?vue&type=script&lang=js&"
export * from "./doorDetail.vue?vue&type=script&lang=js&"
import style0 from "./doorDetail.vue?vue&type=style&index=0&id=16453646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16453646",
  null
  
)

export default component.exports